var _rect, _line, _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTempRadio(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 179,
    viewBox: "0 0 216 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 179,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 30.5,
    x2: 216,
    y2: 30.5,
    stroke: "#E2E2E2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 14.5,
    r: 2.5,
    fill: "#6D6D6D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 14.5,
    r: 2.5,
    fill: "#6D6D6D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 14.5,
    r: 2.5,
    fill: "#6D6D6D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131 121H37C34.7909 121 33 122.791 33 125C33 127.209 34.7909 129 37 129H131C133.209 129 135 127.209 135 125C135 122.791 133.209 121 131 121Z",
    fill: "#747776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 125C27.5 121.686 24.8137 119 21.5 119C18.1863 119 15.5 121.686 15.5 125C15.5 128.314 18.1863 131 21.5 131C24.8137 131 27.5 128.314 27.5 125Z",
    fill: "white",
    stroke: "#747776"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 128.5C23.433 128.5 25 126.933 25 125C25 123.067 23.433 121.5 21.5 121.5C19.567 121.5 18 123.067 18 125C18 126.933 19.567 128.5 21.5 128.5Z",
    fill: "#747776"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104 143H37C34.7909 143 33 144.791 33 147C33 149.209 34.7909 151 37 151H104C106.209 151 108 149.209 108 147C108 144.791 106.209 143 104 143Z",
    fill: "#747776"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 147C27.25 143.824 24.6756 141.25 21.5 141.25C18.3244 141.25 15.75 143.824 15.75 147C15.75 150.176 18.3244 152.75 21.5 152.75C24.6756 152.75 27.25 150.176 27.25 147Z",
    fill: "white",
    stroke: "#747776",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempRadio);
export default __webpack_public_path__ + "static/media/temp-radio.4f06c6a6755750895c0e45d332a6cff8.svg";
export { ForwardRef as ReactComponent };